import * as _ from "lodash";
import {
    PositionGroupAdded,
    PositionGroupsLoaded
} from "./positionGroups.action";
import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import PositionGroup from "domain/positionGroup";

export class PositionGroupsReducer extends ReducerBase<PositionGroup[]> {
  constructor() {
    super();
    this.addHandler(PositionGroupsLoaded.EventName, this.handlePositionGroupsLoaded);
    this.addHandler(PositionGroupAdded.EventName, this.handlePositionGroupsAdded);
  }

  handlePositionGroupsLoaded(
    state: PositionGroup[] = initialState.positionGroups,
    event: PositionGroupsLoaded
  ): PositionGroup[] {
    return event.positionGroups;
  }

  handlePositionGroupsAdded(
    state: PositionGroup[] = initialState.positionGroups,
    event: PositionGroupAdded
  ): PositionGroup[] {
    return _.sortBy([...state, { ...event.newPositionGroup }], [l => l.name?.toLowerCase()]);
  }

  handleDefault(state: PositionGroup[] = initialState.positionGroups) {
    return state;
  }
}
